import Chess from './Chess';

export default Chess;



// WEBPACK FOOTER //
// ./src/components/Building/Chess/index.js